
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "react-image-lightbox/style.css";

const RecentGallery = () => {
    const [imagePaths, setImagePaths] = useState([]);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);

    const galleryRef = useRef(null);

    useEffect(() => {
        axios
            .get("https://online.funforay.com/admin/public/api/gallery")
            .then((res) => {
                if (res.data.status) {
                    const imgs = res.data.data.map((item) => item.image);

                    imgs.forEach((src) => {
                        const image = new Image();
                        image.src = src;
                    });

                    setImagePaths(imgs);
                }
            })
            .catch(console.log);
    }, []);

    // Mobile Auto Slider
    useEffect(() => {
        if (imagePaths.length <= 1) return;

        const gallery = galleryRef.current;
        if (!gallery) return;

        const mediaQuery = window.matchMedia("(max-width: 767px)");

        if (!mediaQuery.matches) return;

        const interval = setInterval(() => {
            const firstItem = gallery.querySelector(".masonry-item");

            if (!firstItem) return;

            const itemWidth = firstItem.offsetWidth;
            const gap = parseFloat(getComputedStyle(gallery).gap) || 0;

            const maxScroll = gallery.scrollWidth - gallery.clientWidth;

            if (gallery.scrollLeft + itemWidth + gap >= maxScroll - 5) {
                gallery.scrollTo({
                    left: 0,
                    behavior: "smooth"
                });
            } else {
                gallery.scrollBy({
                    left: itemWidth + gap,
                    behavior: "smooth"
                });
            }
        }, 3000);

        return () => clearInterval(interval);

    }, [imagePaths]);

    return (
        <section className="gallery">
            <h2 className="gallery_title">Guest Recent Gallery</h2>
            <h2 className="gallery_subtitle"></h2>

            <div className="masonry-gallery" ref={galleryRef}>
                {imagePaths.map((img, index) => (
                    <div
                        key={index}
                        className="masonry-item"
                        onClick={() => {
                            setPhotoIndex(index);
                            setLightboxOpen(true);
                        }}
                    >
                        <img
                            src={img}
                            alt={`Gallery ${index + 1}`}
                            className="masonry-image"
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default RecentGallery;
